import { BoutonMessages } from './bouton-messages';
import { BreadcrumbMessages } from './breadcrumb-messages';

export class ListerAvisMessages {

  public boutonMessages = new BoutonMessages();
  public breadcrumbMessages = new BreadcrumbMessages();

  public title = 'lister.title';
  public creerAP = this.boutonMessages.creerAP;
  public titles = this.breadcrumbMessages.title;

  constructor() {
  }
}
